import { FRANCETV_ENDPOINT_FN, DEFAULT_REFRESH } from './types/index';
import {
  setPromiseTimeout, createState, programHasChanged
} from './utils';

export default class LiveController {
  constructor(player, config = {}) {
    this.config = {
      buildURL: FRANCETV_ENDPOINT_FN, refresh: DEFAULT_REFRESH, ...config
    };
    this.player = player;
  }

  start(media) {
    (async () => {
      if (media?.name) {
        this.generator = this.metaDataGenerator(media);

        for await (const data of this.generator) { /* eslint-disable-line */
          this.player.setTitles(data);
        }
      }
    })();
  }

  reset() {
    this.generator?.return();
  }

  async* metaDataGenerator({
    name,
    videoAdditionalTitle: additionalTitle,
    videoPreTitle: preTitle,
    videoTitle: title
  }) {
    const [state, setState] = createState({ title, preTitle, additionalTitle });
    while (true) {
      setState(await this.fetchMetaData(name, programHasChanged(state))); /* eslint-disable-line */
      yield state;
    }
  }

  async fetchMetaData(channelId, validate) {
    try {
      const metadata = await (await fetch(this.config.buildURL(channelId))).json();
      if (!validate(metadata)) throw new Error('Metadata sync error');
      return metadata;
    } catch (e) {
      return setPromiseTimeout(() => this.fetchMetaData(channelId, validate), this.config.refresh);
    }
  }
}
